// Global packages and components
import { clsx } from 'clsx'
import { Link } from '@remix-run/react'
import { Button, ContentEditor, Image, Video } from '~/components'
import { backgroundColourClass, getLinkType } from '~/utils'

// Types
import type { PortableTextBlock } from '@portabletext/react'
import type {
  SanityButtonProps,
  SanityCustomFile,
  SanityRefWithAlt,
} from '~/types'

interface BlockBannerNarrowProps {
  mediaType?: string
  image?: SanityRefWithAlt
  video?: SanityCustomFile
  offerRoundal?: SanityRefWithAlt
  content?: PortableTextBlock[]
  button?: SanityButtonProps
  flip?: boolean
  extendImage?: boolean
  backgroundColor?: string
  oembed?: string
  mobileOembed?: string
}

// Main export
export default function BlockBannerNarrow({
  mediaType,
  image,
  video,
  offerRoundal,
  content,
  flip = false,
  button,
  backgroundColor = 'transparent',
  oembed,
  mobileOembed,
}: BlockBannerNarrowProps = {}) {
  return (
    <div className="container">
      <Link
        to={getLinkType({
          linkType: button?.linkType,
          linkReference: button?.linkReference,
          linkSlug: button?.linkSlug,
          linkExternal: button?.linkExternal,
        })}
        className={clsx('group/wrapper block rounded-xl', {
          [backgroundColourClass(backgroundColor)]: backgroundColor,
        })}
      >
        <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-8">
          <div
            className={clsx('order-2 flex flex-col justify-center py-8', {
              'px-8 lg:order-1 lg:pr-0': !flip,
              'px-8 lg:order-2 lg:pl-0': flip,
            })}
          >
            <div className="mb-6">
              {content && <ContentEditor content={content} />}
            </div>
            {button && (
              <div>
                <Button
                  {...button}
                  mimic={true}
                />
              </div>
            )}
          </div>
          <div
            className={clsx(
              'relative order-1 flex aspect-banner justify-center lg:aspect-auto',
              {
                'lg:order-2': !flip,
                'lg:order-1': flip,
              }
            )}
          >
            {offerRoundal && (
              <Image
                image={offerRoundal}
                customSize={96}
                className="absolute right-5 top-5 z-[1] max-w-24"
              />
            )}
            {mediaType == 'image' && image?.asset ? (
              <Image
                image={image}
                imageSize="half"
                className="absolute right-0 top-0 h-full w-full rounded-t-xl object-cover lg:rounded-br-xl lg:rounded-tl-none"
              />
            ) : mediaType == 'video' && video?.asset.url ? (
              <div className="absolute right-0 top-0 size-full overflow-hidden rounded-2xl">
                <Video
                  videoType={'file'}
                  videoTitle="Bannner background video"
                  file={video}
                  autoplay
                  mobileAutoplay
                />
              </div>
            ) : mediaType == 'oembed' && oembed ? (
              <div className="absolute right-0 top-0 size-full overflow-hidden rounded-2xl">
                <Video
                  videoType={'oembed'}
                  videoTitle="Bannner background video"
                  oembed={oembed}
                  mobileOembed={mobileOembed}
                  autoplay
                  mobileAutoplay
                />
              </div>
            ) : null}
          </div>
        </div>
      </Link>
    </div>
  )
}
